import styled from 'styled-components'
import {PageBody} from '@/components/ui/page-atoms/PageAtoms'

export const StyledPageBody = styled(PageBody)`
    grid-template-rows: auto minmax(0, 1fr);
`
